import { module } from 'modujs';
import gsap from 'gsap';
import { SplitText } from '../vendor/gsap-esm/SplitText';
import { ScrollTrigger } from '../vendor/gsap-esm/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger, SplitText);

export default class extends module {
  constructor(m) {
    super(m);
  }

  init() {
    this.DOM = {
      view: this.el,
    };
    this.FX = {
      titleLines: new SplitText(this.DOM.view, { type: 'lines' }),
      titleChars: new SplitText(this.DOM.view, {
        type: 'chars',
        charsClass: 'tw-invisible',
      }),
    };
    this.setup();
    gsap.delayedCall(1, () => {
      this.fx();
    });
  }

  fx() {
    this.animate();
    this.reveal();
  }

  animate() {
    this.animation = gsap.timeline();

    this.animation
      .add([
        gsap.fromTo(
          this.FX.titleChars.chars,
          {
            autoAlpha: 0,
          },
          {
            autoAlpha: 1,
            ease: 'quart.out',
            duration: 0.1,
            stagger: 0.03,
            immediateRender: false,
          }
        ),
      ])
      .add(
        [
          gsap.fromTo(
            this.FX.titleChars.chars,
            {
              y: 50,
            },
            {
              y: 0,
              ease: 'quart.out',
              duration: 1,
              stagger: 0.03,
              immediateRender: false,
            }
          ),
        ],
        '<'
      );
  }

  setup() {
    gsap.set(this.FX.titleChars.chars, { autoAlpha: 0 });
  }

  reveal() {
    this.st = ScrollTrigger.create({
      animation: this.animation,
      trigger: this.DOM.view,
      start: 'top 50%',
    });
  }

  destroy() {
    this.st.kill(true);
  }
}
